import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import HeaderSection from "../../components/HeaderSection";
import { getAllUserExceptAdmin, addJobDetails,getTeams } from "../../http";

const AddJobUser = () => {
  const initialState = {
    userId: "",
    team: "",
    esd: "",
    jd: "",
    joblocation: "",
    jobtitle: "",
    workshift: "",
    employmentStatus: "Full-time", // Default value
    employmentType: "Permanent" // Default value
  };

  const [formData, setFormData] = useState(initialState);
  const [allUsers, setAllUsers] = useState([]);
  const [allTeamMember,setAllTeamMember] = useState([]);
  const [maxDate,setMaxDate] = useState("");
  const fetchTeams = async ()=>{
    try {
     const response = await getTeams();
     console.log(response.data.success);
      if(response.data.success) 
      {
        
        setAllTeamMember(response.data.data);
        console.log(response.data.data);
      }
      else
      {
        toast.error("Unable to fetch Team Member Records")
      }
    }
      catch(err)
        {
          toast.error("Error fetching Team Members");
        }
    }

    useEffect(() => {
      // Get today's date in YYYY-MM-DD format
      const today = new Date();
      const formattedDate = today.toISOString().split("T")[0];
      setMaxDate(formattedDate);
  }, []);
  
  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const response = await getAllUserExceptAdmin();
        if (response.data.success) {
          setAllUsers(response.data.data);
        } else {
          toast.error("Unable to fetch user records");
        }
      } catch (error) {
        toast.error("Error fetching users");
      }
    };
    fetchUsers();
    fetchTeams();
  }, []);

  const inputEvent = (e) => {
    const { name, value } = e.target;

    console.log(value);
    setFormData((prevState) => ({
      ...prevState,
      [name]: value
    }));
  };

  const onSubmit = async (e) => {
    e.preventDefault();
   
    const {
      userId,
      team,
      esd,
      jd,
      joblocation,
      jobtitle,
      workshift,
      employmentStatus,
      employmentType
    } = formData;

    console.log(formData);
    if (
      !userId ||
      !team ||
      !esd ||
      !jd ||
      !joblocation ||
      !jobtitle ||
      !workshift ||
      !employmentStatus ||
      !employmentType
    ) {
      return toast.error("All fields are required.");
    }

    const alphabetRegex = /^[A-Za-z\s]+$/;

    if (!alphabetRegex.test(jobtitle)) {
      return toast.error("Job Title should only contain alphabets.");
    }
  
    if (!alphabetRegex.test(joblocation)) {
      return toast.error("Job Location should only contain alphabets.");
    }
  
    if (!alphabetRegex.test(workshift)) {
      return toast.error("Work Shift should only contain alphabets.");
    }
  
    if (!alphabetRegex.test(jd)) {
      return toast.error("Job Description should only contain alphabets.");
    }

    console.log(team);
    try {
      const res = await addJobDetails(formData);
    
      if (res.data.success) {
        setFormData({ ...initialState });
        toast.success(res.data.message || "Job description added successfully!");
      } else if (res.data.error) {
        // Handle API error messages gracefully
        toast.error(res.data.error || "Something went wrong. Please try again.");
      }
    } catch (error) {
      // Handle unexpected errors (e.g., network issues)
      const errorMessage = error.response?.data?.error || "An unexpected error occurred";
      toast.error(errorMessage);
    }
    
  };

  console.log(allTeamMember);

  return (
    <>
      <div className="main-content">
        <section className="section">
          <HeaderSection title="Add Job Description" />
          <div className="card">
            <div className="card-body pr-5 pl-5 m-1">
              <form className="row" onSubmit={onSubmit}>
                {/* Select Employee */}
                <div className="form-group col-md-4">
                  <label for="userId">Select Employee <span style={{ color: 'red' }}>*</span></label>
                  
                  <div className="input-group">
                    <div className="input-group-prepend">
                      <div className="input-group-text">
                        <i className="fas fa-user"></i>
                      </div>
                    </div>
                    <select
                      value={formData.userId}
                      onChange={inputEvent}
                      id="userId"
                      name="userId"
                      className="form-control"
                      required
                    >
                      <option value="" disabled>
                        Select a user
                      </option>
                      {allUsers.map((user) => (
                        <option key={user._id} value={user._id}>
                          {user.name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                {/* Job Title */}
                <div className="form-group col-md-4">
                  <label for="jobtitle">Enter Job Title <span style={{ color: 'red' }}>*</span></label>
                  <div className="input-group">
                    <div className="input-group-prepend">
                      <div className="input-group-text">
                        <i className="fas fa-file-alt"></i>
                      </div>
                    </div>
                    <input
                      onChange={inputEvent}
                      value={formData.jobtitle}
                      type="text"
                      id="jobtitle"
                      name="jobtitle"
                      className="form-control"
                      required
                    />
                  </div>
                </div>

                {/* Select Team */}
                <div className="form-group col-md-4">
                  <label for="team">Select Team <span style={{ color: 'red' }}>*</span></label>
                  <select
                      value={formData.team}
                      onChange={inputEvent}
                      id="team"
                      name="team"
                      className="form-control"
                      required
                    >
                      <option value="" disabled>
                        Select a Team
                      </option>
                      {allTeamMember.length === 0  ?  <option>N/A</option>: (allTeamMember.map((team) => (
                        <option key={team?._id} value={team?._id}>
                          {team?.name}
                        </option>
                      )))}
                    </select>
                  {/* <div className="input-group">
                    <div className="input-group-prepend">
                      <div className="input-group-text">
                        <i className="fas fa-file-alt"></i>
                      </div>
                    </div>
                    <input
                      onChange={inputEvent}
                      value={formData.department}
                      type="text"
                      id="department"
                      name="department"
                      className="form-control"
                    />
                  </div> */}
                </div>

                {/* Employment Status */}
                <div className="form-group col-md-4">
                  <label for="employmentStatus">Select Employment Status <span style={{ color: 'red' }}>*</span></label>
                  <select
                    name="employmentStatus"
                    onChange={inputEvent}
                    value={formData.employmentStatus}
                    className="form-control select2"
                    required
                  >
                    <option value="" disabled>
                      Select Employment Status
                    </option>
                    <option value="Full-time">Full-time</option>
                    <option value="Part-time">Part-time</option>
                    <option value="Contract">Contract</option>
                  </select>
                </div>

                {/* Employment Type */}
                <div className="form-group col-md-4">
                  <label for="employmentType">Select Employment Type <span style={{ color: 'red' }}>*</span></label>
                  <select
                    name="employmentType"
                    onChange={inputEvent}
                    value={formData.employmentType}
                    className="form-control select2"
                    onKeyDown={(e)=>e.preventDefault()}
                    required
                  >
                    <option value="" disabled>
                      Select Employment Type
                    </option>
                    <option value="Permanent">Permanent</option>
                    <option value="Temporary">Temporary</option>
                    <option value="Internship">Internship</option>
                  </select>
                </div>

                {/* Employment Start Date */}
                <div className="form-group col-md-4">
                  <label for="esd">Employment Start Date <span style={{ color: 'red' }}>*</span></label>
                  <div className="input-group">
                    <div className="input-group-prepend">
                      <div className="input-group-text">
                        <i className="fas fa-calendar-alt"></i>
                      </div>
                    </div>
                    <input
                      onChange={inputEvent}
                      value={formData.esd}
                      type="date"
                      id="esd"
                      name="esd"
                      className="form-control"
                      max={maxDate}
                    />
                  </div>
                </div>

                {/* Employment End Date */}
                {/* <div className="form-group col-md-4">
                  <label>Employment End Date</label>
                  <div className="input-group">
                    <div className="input-group-prepend">
                      <div className="input-group-text">
                        <i className="fas fa-calendar-alt"></i>
                      </div>
                    </div>
                    <input
                      onChange={inputEvent}
                      value={formData.eed}
                      type="date"
                      id="eed"
                      name="eed"
                      className="form-control"
                    />
                  </div>
                </div> */}

                {/* Job Location */}
                <div className="form-group col-md-4">
                  <label for="joblocation">Job Location <span style={{ color: 'red' }}>*</span></label>
                  <div className="input-group">
                    <div className="input-group-prepend">
                      <div className="input-group-text">
                        <i className="fas fa-map-marker-alt"></i>
                      </div>
                    </div>
                    <input
                      onChange={inputEvent}
                      value={formData.joblocation}
                      type="text"
                      id="joblocation"
                      name="joblocation"
                      className="form-control"
                      required
                    />
                  </div>
                </div>

                {/* Work Shift */}
                <div className="form-group col-md-4">
                  <label for="workshift">Work Shift <span style={{ color: 'red' }}>*</span></label>
                  <div className="input-group">
                    <div className="input-group-prepend">
                      <div className="input-group-text">
                        <i className="fas fa-clock"></i>
                      </div>
                    </div>
                    <input
                      onChange={inputEvent}
                      value={formData.workshift}
                      type="text"
                      id="workshift"
                      name="workshift"
                      className="form-control"
                      required
                    />
                  </div>
                </div>

                {/* Job Description */}

                <div className="form-group col-md-12">
                  <label for="jd">Enter Job Description <span style={{ color: 'red' }}>*</span></label>
                  <div className="input-group">
                    <div className="input-group-prepend">
                      <div className="input-group-text">
                        <i className="fas fa-file-alt"></i>
                      </div>
                    </div>
                    <input
                      onChange={inputEvent}
                      value={formData.jd}
                      type="text"
                      id="jd"
                      name="jd"
                      className="form-control"
                    />
                  </div>
                </div>

                {/* Submit Button */}
                <div className="form-group text-center col-md-12">
                  <button
                    className="btn btn-primary btn-lg"
                    type="submit"
                    style={{ width: "30vh" }}
                  >
                    Add Job Details
                  </button>
                </div>
              </form>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default AddJobUser;
